import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { companiesService } from '@/features/companies/services/companies.service';
import { CompanyList } from '@/features/companies/components/CompanyList';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { PageHeader } from '@/components/ui/page-header';
import { useState } from 'react';
import { CompanyForm } from '@/features/companies/components/CompanyForm';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export const Route = createFileRoute('/_authenticated/companies/')({
  component: CompaniesPage,
});

function CompaniesPage() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const { data: companies = [], isLoading } = useQuery({
    queryKey: ['companies-list'],
    queryFn: () => companiesService.listCompanies(),
  });

  const createMutation = useMutation({
    mutationFn: companiesService.createCompany,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['companies-list'] });
      toast({ title: 'Empresa criada com sucesso' });
      setCreateDialogOpen(false);
      navigate({ to: `/companies/${data.id}` });
    },
  });

  return (
    <div className="space-y-6">
      <PageHeader
        title="Empresas"
        description="Lista de empresas cadastradas."
        actions={
          <Button onClick={() => setCreateDialogOpen(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Nova empresa
          </Button>
        }
      />

      <Card>
        <CardHeader>
          <CardTitle>Lista de Empresas</CardTitle>
        </CardHeader>
        <CardContent>
          <CompanyList
            companies={companies}
            isLoading={isLoading}
            onSelect={(id) => navigate({ to: `/companies/${id}` })}
          />
        </CardContent>
      </Card>

      <Dialog open={createDialogOpen} onOpenChange={setCreateDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Criar Empresa</DialogTitle>
          </DialogHeader>
          <CompanyForm
            onSubmit={(data) => createMutation.mutate(data)}
            onCancel={() => setCreateDialogOpen(false)}
            isLoading={createMutation.isPending}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
